<template>
  <div id="func-11">
    <FuncionalidadeHeader titulo="Detalhe da Coparticipação"/>

    <el-row class="func-detalhe" id="func-detalhes">
      <el-col :span="14" class="func-infos">
        <el-row class="func-11-item">
          <el-col :span="18">
            <h2 class="func-11-title" style="font-size:25px">{{ params.extrato.descricaoContrato }}</h2>
            <p class="">{{ textoVinculoContrato }}: {{ params.extrato.idContrato }}</p>
          </el-col>
          <el-col :span="6" class="text-right">
            <h2 class="func-11-title" style="font-size:25px">{{ params.mes.label }} {{ params.mes.year }}</h2>
            <p class="func-11-title">
              <b>Total: <span v-html="parseValor(valorTotalCoparticipacao)"></span></b>
            </p>
          </el-col>
        </el-row>

        <el-row class="func-11-item">
          <el-col :span="18">
            <el-tag
              effect="plain"
              :style="`
                background: white; color:${params.corPrimariaAplicacao};
                border-color:${params.corPrimariaAplicacao};
                border-radius: 15px;`
              ">
              {{ params.extrato.chaveUnica ? params.extrato.nomeBeneficiario : 'Todos os Beneficiários' }}
            </el-tag>
          </el-col>
        </el-row>

        <el-row v-if="extratos && extratos.length > 0">

          <ul
            class="func-listagens"
            style="margin-left: 15px"
            v-if="params.parametros.tipoAgrupamentoRegistros === 1"
          >
            <li
              v-for="(extrato, index) in extratos"
              :key="index"
              :name="index"
              class="func-11-li"
            >
              <el-row class="func-11-item" :style="estiloLinha">
                <el-col :span="params.parametros.visualizarValorPorGrupoServico ? 16 : 20">
                  <h2 class="func-11-title" style="padding-top:10px">{{ extrato.nomeBeneficiario }}</h2>
                </el-col>
                <el-col :span="4" class="text-right" v-if="params.parametros.visualizarValorPorGrupoServico">
                  <span class="sub">Serviço (R$)</span>
                  <h2 class="func-11-title" v-html="parseValor(extrato.valorTotalServico)"></h2>
                </el-col>
                <el-col :span="4" class="text-center">
                  <span class="sub">Copart. (R$)</span>
                  <h2 class="func-11-title" v-html="parseValor(extrato.valorTotalCoparticipacao)"></h2>
                </el-col>
              </el-row>

              <div class="listagem-status">

                <ul
                  class="func-listagens"
                  style="padding: 0px 12px 0 15px;"
                >
                  <li
                    v-for="(procedimento, index) in extrato.procedimentos"
                    :key="index"
                    :name="index"
                    class="func-11-li"
                    @click="showDetalhe(procedimento)"
                  >
                    <el-row style="cursor:pointer">
                      <el-col :span="18">
                        <h2 class="func-11-title">{{ procedimento.descricaoProcedimento }}</h2>
                        <span class="sub">{{ parseDate(procedimento.dataAtendimento) }}</span>
                        <span class="sub" style="margin-left:25px">Guia: {{ procedimento.numeroGuia }}</span><br/>
                        <span class="sub">{{ procedimento.localAtendimento }}</span><br/>
                      </el-col>
                      <el-col :span="5" class="text-right">
                        <h2 class="func-11-title" v-html="parseValor(procedimento.valorTotalCoparticipacao)"></h2>
                      </el-col>
                      <el-col :span="1" class="text-right">
                        <i class="el-icon-arrow-right" :style="`color: ${params.corPrimariaAplicacao};`"></i>
                      </el-col>
                    </el-row>
                  </li>
                </ul>
              </div>
            </li>
          </ul>

          <ul
            class="func-listagens"
            style="margin-left: 15px"
            v-else-if="params.parametros.tipoAgrupamentoRegistros === 2"
          >
            <li
              v-for="(extrato, index) in extratos"
              :key="index"
              :name="index"
              class="func-11-li"
            >
              <el-row class="func-11-item" :style="estiloLinha">
                <el-col :span="params.parametros.visualizarValorPorGrupoServico ? 16 : 20">
                  <h2 class="func-11-title" style="padding-top:10px">{{ extrato.tipoServico }}</h2>
                </el-col>
                <el-col :span="4" class="text-right" v-if="params.parametros.visualizarValorPorGrupoServico">
                  <span class="sub">Serviço (R$)</span>
                  <h2 class="func-11-title" v-html="parseValor(extrato.valorTotalServico)"></h2>
                </el-col>
                <el-col :span="4" class="text-center">
                  <span class="sub">Copart. (R$)</span>
                  <h2 class="func-11-title" v-html="parseValor(extrato.valorTotalCoparticipacao)"></h2>
                </el-col>
              </el-row>

              <div class="listagem-status">

                <ul
                  class="func-listagens"
                  style="padding: 0px 12px 0 15px;"
                >
                  <li
                    v-for="(procedimento, index) in extrato.procedimentos"
                    :key="index"
                    :name="index"
                    class="func-11-li"
                    @click="showDetalhe(procedimento)"
                  >
                    <el-row style="cursor:pointer">
                      <el-col :span="18">
                        <h2 class="func-11-title">{{ procedimento.descricaoProcedimento }}</h2>
                        <span class="sub">{{ parseDate(procedimento.dataAtendimento) }}</span>
                        <span class="sub" style="margin-left:25px">Guia: {{ procedimento.numeroGuia }}</span><br/>
                        <span class="sub">{{ procedimento.localAtendimento }}</span><br/>
                        <span class="sub">{{ procedimento.nomeBeneficiario }}</span>
                      </el-col>
                      <el-col :span="5" class="text-right">
                        <h2 class="func-11-title" v-html="parseValor(procedimento.valorTotalCoparticipacao)">
                        </h2>
                      </el-col>
                      <el-col :span="1" class="text-right">
                        <i class="el-icon-arrow-right" :style="`color: ${params.corPrimariaAplicacao};`"></i>
                      </el-col>
                    </el-row>
                  </li>
                </ul>

              </div>
            </li>
          </ul>
        </el-row>
      </el-col>

      <el-col :span="10" >
        <el-row class="func-11-item" style="margin-left: 20px;">
          <el-col :span="24" :style="`padding-left: 15px; border-radius: 10px; ${estiloLinha}`" >

            <el-row class="func-11-item" type="flex" justify="end">
              <el-col :span="4" class="text-center" v-if="params.parametros.visualizarTotalServico">
                <p class="sub">Serviço (R$)</p>
              </el-col>
              <el-col :span="4" class="text-center">
                <p class="sub">Copart. (R$)</p>
              </el-col>
            </el-row>
            <el-row class="func-11-item" style="padding-top:5px">
              <el-col :span="params.parametros.visualizarTotalServico ? 16 : 20">
                <b><span>{{ params.parametros.labelTotilizador }}</span></b>
              </el-col>
              <el-col :span="4" class="text-center" v-if="params.parametros.visualizarTotalServico">
                <b><span v-html="parseValor(valorTotalServico)"></span></b>
              </el-col>
              <el-col :span="4" class="text-center">
                <b><span v-html="parseValor(valorTotalCoparticipacao)"></span></b>
              </el-col>
            </el-row>

            <el-row class="func-11-item">
              <ul class="func-listagens">
                <li
                  v-for="(extrato, index) in extratoBeneficiarios"
                  :key="index"
                  :name="index"
                >
                  <el-row style="margin-bottom: 15px;">
                    <el-col :span="params.parametros.visualizarTotalServico ? 16 : 20">
                      <span>{{ extrato.nomeBeneficiario }} - {{ extrato.tipoUsuario }}</span>
                    </el-col>
                    <el-col :span="4" class="text-center" v-if="params.parametros.visualizarTotalServico">
                      <span v-html="parseValor(extrato.valorTotalServico)"></span>
                    </el-col>
                    <el-col :span="4" class="text-center">
                      <span v-html="parseValor(extrato.valorTotalCoparticipacao)"></span>
                    </el-col>
                  </el-row>
                </li>
              </ul>
            </el-row>
          </el-col>
        </el-row>
      </el-col>

      <DialogDefault
        title="Detalhes do Serviço"
        :open.sync="showDialog"
        width="40%"
        :closeOnClickModal="false"
        v-if="procedimentoDetalhe"
      >
        <Func11DetalheServico :procedimento="procedimentoDetalhe" :funcParametros="params.parametros"></Func11DetalheServico>
      </DialogDefault>
    </el-row>
  </div>
</template>
<script>

import FuncionalidadeHeader from '@/components/FuncionalidadeHeader/FuncionalidadeHeader'
import moment from 'moment'
import DialogDefault from '@/components/DialogDefault/DialogDefault'
import Func11DetalheServico from './Func11DetalheServico'
import { mapGetters } from 'vuex'

export default {
  name: 'Func11Detalhe',
  components: {
    DialogDefault,
    FuncionalidadeHeader,
    Func11DetalheServico
  },
  data () {
    return {
      showDialog: false,
      params: {},
      extratos: [],
      extratoBeneficiarios: [],
      valorTotalServico: 0,
      valorTotalCoparticipacao: 0,
      procedimentoDetalhe: null,
      estiloLinha: ''
    }
  },
  computed: {
    ...mapGetters('SetupApp', ['aplicacao', 'textoVinculoContrato'])
  },
  methods: {
    parseValor: function (valor) {
      return `R$ ${Math.floor(valor)},<span>${(valor - Math.floor(valor)).toFixed(2).split('.')[1]}</span>`
    },
    parseDate: function (value) {
      return moment(value, 'YYYY-MM-DD').format('DD/MM/YYYY')
    },
    getTipoUsuario (idTipoUsuario) {
      let tipoUsuario = ''
      switch (idTipoUsuario) {
        case 'T':
          tipoUsuario = 'Titular'
          break
        case 'D':
          tipoUsuario = 'Dependente'
          break
        case 'A':
          tipoUsuario = 'Agregado'
          break
      }
      return tipoUsuario
    },
    agruparPorTipoAgrupamento (arr, tipoAgrupamento) {
      const result = arr.reduce(function (r, a) {
        if (tipoAgrupamento === 'beneficiario') {
          r[a.chaveUnica] = r[a.chaveUnica] || []
          r[a.chaveUnica].push(a)
        } else if (tipoAgrupamento === 'servico') {
          r[a.idTipoServico] = r[a.idTipoServico] || []
          r[a.idTipoServico].push(a)
        }
        return r
      }, Object.create(null))

      return result
    },
    criarObjExtrato (mappedData) {
      const extrato = {}
      extrato.nomeBeneficiario = mappedData[0].nomeBeneficiario
      extrato.tipoServico = mappedData[0].descricaoTipoServico
      extrato.idTipoUsuario = mappedData[0].idTipoUsuario
      extrato.chaveUnica = mappedData[0].chaveUnica
      extrato.idContrato = mappedData[0].idContrato
      extrato.valorTotalServico = 0
      extrato.valorTotalCoparticipacao = 0
      extrato.procedimentos = Object.keys(mappedData).map(key => mappedData[key])
      extrato.tipoUsuario = this.getTipoUsuario(mappedData[0].idTipoUsuario)

      extrato.procedimentos.map(proc => {
        let quantidade = proc.quantidade ? proc.quantidade : 1
        let valorCoparticipacao = proc.valorCoparticipacao * quantidade
        let valorServico = proc.valorServico * quantidade

        proc.tipoUsuario = extrato.tipoUsuario
        proc.valorTotalCoparticipacao = valorCoparticipacao

        extrato.valorTotalServico += valorServico
        extrato.valorTotalCoparticipacao += valorCoparticipacao
      })

      return extrato
    },
    getData (procedimentos, tipoAgrupamento) {
      this.params.extrato.valorTotalPorContrato = 0
      const result = this.agruparPorTipoAgrupamento(procedimentos, tipoAgrupamento)

      for (const key in result) {
        const mappedData = { ...result[key] }
        const extrato = this.criarObjExtrato(mappedData)

        this.params.extrato.valorTotalPorContrato += extrato.valorTotalCoparticipacao
        this.extratos.push(extrato)
      }
    },
    agruparPorBeneficiario () {
      if (this.params.extrato.chaveUnica) {
        this.getData(this.params.extrato.procedimentos, 'beneficiario')
      } else {
        this.params.extrato.procedimentos.map((item, key) => {
          this.getData(item.procedimentos, 'beneficiario')
        })
      }
    },
    agruparPorServico () {
      if (this.params.extrato.chaveUnica) {
        this.getData(this.params.extrato.procedimentos, 'servico')
      } else {
        this.params.extrato.procedimentos.map((item, key) => {
          this.getData(item.procedimentos, 'servico')
        })
      }
    },
    agruparTotais () {
      if (this.params.extrato.chaveUnica) {
        const result = this.agruparPorTipoAgrupamento(this.params.extrato.procedimentos, 'beneficiario')

        for (const key in result) {
          const mappedData = { ...result[key] }
          const extrato = this.criarObjExtrato(mappedData)

          this.valorTotalServico += extrato.valorTotalServico
          this.valorTotalCoparticipacao += extrato.valorTotalCoparticipacao
          this.extratoBeneficiarios.push(extrato)
        }
      } else {
        this.params.extrato.procedimentos.map((item) => {
          const result = this.agruparPorTipoAgrupamento(item.procedimentos, 'beneficiario')

          for (const key in result) {
            const mappedData = { ...result[key] }
            const extrato = this.criarObjExtrato(mappedData)

            this.valorTotalServico += extrato.valorTotalServico
            this.valorTotalCoparticipacao += extrato.valorTotalCoparticipacao
            this.extratoBeneficiarios.push(extrato)
          }
        })
      }
    },
    showDetalhe (procedimento) {
      this.procedimentoDetalhe = procedimento
      this.showDialog = true
    }
  },
  created () {
    const storage = localStorage.getItem('params')
    if (storage) {
      this.params = JSON.parse(storage)

      this.estiloLinha = `background: ${this.params.corPrimariaAplicacao}0d !important`

      if (this.params.parametros.tipoAgrupamentoRegistros === 1) {
        this.agruparPorBeneficiario()
      } else if (this.params.parametros.tipoAgrupamentoRegistros === 2) {
        this.agruparPorServico()
      }

      this.agruparTotais()
    }
  }
}
</script>
